
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Submits a signal representing applicant activity on your recruitment software.`}</p>
    <p>{`Caution: this is currently under development and may be changed or removed without notice.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;